import { render } from "./NewsCard.vue?vue&type=template&id=f2f7a664&scoped=true"
import script from "./NewsCard.vue?vue&type=script&lang=js"
export * from "./NewsCard.vue?vue&type=script&lang=js"

import "./NewsCard.vue?vue&type=style&index=0&id=f2f7a664&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2f7a664"]])

export default __exports__